// src/components/ui/Navigation.tsx
// ============================================================================
// PUBLIC HEADER NAVIGATION
// Sticky header for public pages (Home, About, Sign In)
// Features: Logo + links, sticky, theme-locked, interactive NavLink components
// ============================================================================


import React from 'react';
import Link from 'next/link';
import { NavLink } from '@/components/ui/NavLink';
import { theme } from '@/lib/theme';

export const Navigation = React.memo(() => {
  return (
    <header style={{ position: 'sticky', top: 0, zIndex: theme.tokens.zIndex.sticky, borderBottom: `1px solid rgba(198, 161, 74, ${theme.tokens.opacity.goldDefault})`, backgroundColor: theme.colors.paper, padding: `${theme.tokens.spacing[4]} ${theme.tokens.spacing[6]}`, boxShadow: theme.shadows.elevation.sm }}>
      <nav style={{ maxWidth: '1440px', margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: theme.tokens.gap.lg }}>
        <Link href="/" style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', gap: theme.tokens.spacing[1] }}>
          <h1 style={{ margin: 0, fontSize: theme.typography.sizes['2xl'], fontWeight: theme.typography.weights.bold, color: theme.colors.ink, fontFamily: theme.typography.fonts.primary }}>The Deck Compass</h1>
          <p style={{ margin: 0, fontSize: theme.typography.sizes.sm, color: theme.colors.muted, fontFamily: theme.typography.fonts.primary, fontWeight: theme.typography.weights.normal }}>A sacred space for reading and reflection</p>
        </Link>

        <div style={{ display: 'flex', gap: theme.tokens.gap.lg, alignItems: 'center' }}>
          <NavLink href="/about" variant="text">About</NavLink>
          <NavLink href="/sign-in" variant="button">Sign In</NavLink>
        </div>
      </nav>
    </header>
  );
});

Navigation.displayName = 'Navigation';

export default Navigation;